export enum SuppliesDiscountValueKind {
  Percentage = "percentage",
  FixedAmount = "fixed_amount",
}
